import { flexWorkerService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';
import { useQuery } from 'react-query';
import { EmploymentType } from '@types';

export const useGetWorkerList = (search: string, employmentType?: EmploymentType) => {
  const queryFn = async () => await flexWorkerService.getWorkerList(search, employmentType);

  return useQuery(QUERY_KEYS.workerList(search), queryFn, { enabled: search.length > 2 });
};
